import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Skeleton } from './ui/skeleton';

// Portal-only progressive slot. Without `section` (internal panel) it just renders children.
export const ReportSlot = ({ section, children, minHeight = 220, testId }) => {
  if (!section) return children();
  if (section.status === 'error') {
    return (
      <Card data-testid={`${testId}-error`}>
        <CardContent className="py-8 flex flex-col items-center text-center gap-3">
          <AlertCircle className="h-5 w-5 text-muted-foreground" />
          <p className="text-sm text-muted-foreground">{section.error || 'Não foi possível carregar esta métrica agora'}</p>
          <Button variant="outline" size="sm" onClick={section.onRetry} data-testid={`${testId}-retry`}>
            <RefreshCw className="h-3.5 w-3.5 mr-2" /> Tentar novamente
          </Button>
        </CardContent>
      </Card>
    );
  }
  if (!section.payload) {
    return (
      <Card data-testid={`${testId}-skeleton`}>
        <CardContent className="pt-6 space-y-3" style={{ minHeight }}>
          <Skeleton className="h-5 w-48" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-5/6" />
          <Skeleton className="h-4 w-2/3" />
          <Skeleton className="h-24 w-full" />
        </CardContent>
      </Card>
    );
  }
  return <div data-testid={`${testId}-ready`} className="space-y-6">{children()}</div>;
};
